import { RMS_PROVIDER_USER_TYPES, RMS_TEACHER_USER_TYPE } from '../../constants/userTypes';

const GUARDIAN_USER_TYPE = 'RMS Legal Guardian';

/**
 * Where "go home" takes each person in the portal (TDI-697, R-013): the one
 * page their role can always open. Signed out goes to the parent or carer
 * sign-in, because a page with no session cannot tell who someone is (school
 * staff move between sign-in pages from there, F-01). `family` says whether
 * the home is on the parent or carer side, which decides the button colour.
 */
export function rmsHomeFor({ signedIn, userType }) {
  if (!signedIn) return { to: '/rms/family/sign-in', label: 'Go to sign in', family: true };
  if (userType === GUARDIAN_USER_TYPE) return { to: '/rms/family/children', label: 'Go to your children', family: true };
  if (userType === RMS_TEACHER_USER_TYPE) return { to: '/rms/teacher', label: 'Go to your forms', family: false };
  if (RMS_PROVIDER_USER_TYPES.includes(userType)) {
    return { to: '/rms/provider/dashboard', label: 'Go to your dashboard', family: false };
  }
  return { to: '/rms/pupils', label: 'Go to your pupils', family: false };
}
